module.exports = __webpack_public_path__ + "static_pc/img/14.42ceadfb.jpg";